export const elements = {
    soda: { type: 'item', key: 'soda', position: [0,0,0], rotation: [20.0,0.0,0], scale: [0.02,0.02,0.02], data:{}},
    hotdog: { type: 'item', key: 'hotdog', position: [0,0,0], rotation: [20.0,0.0,0], scale: [0.02,0.02,0.02], data:{}},
};